// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mbdwhhbcgbadnmkehtli.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1iZHdoaGJjZ2JhZG5ta2VodGxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyMTE4MjgsImV4cCI6MjA1OTc4NzgyOH0.jLWlWEuN7gc5ofSQaP1Tjlq1gl2Nbz8RpyrrrIrMjMw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);